import urls from "./net-urls";
import proreq from '../proto/request_pb'
import proresp from '../proto/response_pb'

const Socket = {
  ctx: null,
  _socket: null,

  init(ctx) {
    this.ctx = ctx;
  },

  connect() {
    try{
      if(this.isConnected() || this.isConnecting()){
        this.disConnect()
      }
    }catch (err) {
      this.ctx.$logger.error(err)
    }

    let self = this
    let socket = new WebSocket(this.buildUrl(urls.websock));
    socket.binaryType = "arraybuffer";
    socket.onopen = self.onOpen.bind(this)

    socket.onerror = self.onError.bind(this)

    socket.onmessage = self.onMessage.bind(this)
    socket.onclose = self.onClose.bind(this)

    this._socket = socket;
  },

  last_reconnect: 0,
  reConnect() {
    if (this.isConnecting()) {
      return;
    }

    let self = this

    let delta = 2;
    let now_reconnect = new Date().getTime()
    if(now_reconnect - this.last_reconnect > 2000){
      delta = 0;
    }
    this.last_reconnect = now_reconnect;
    setTimeout(function () {
      if(self.isConnecting()){
        return;
      }
      self.connect()
    }, 2000)
  },

  buildUrl(wsuri) {
    return `${wsuri}?aid=${this.ctx.$info.id}&token=${this.ctx.$info.soaToken}`
  },

  onOpen(event) {
    this.ctx.$logger.log('socket 连接成功')
    this.startHeart()
    this.ctx.$handles.onConnected(event)
  },

  onError(event) { //错误
    this.ctx.$logger.error("socket error", event);
    this.reConnect()
  },

  onMessage(event) { //数据接收
    let logger = this.ctx.$logger

    let self = this
    try {
      let _data = event.data

      if (_data instanceof Blob) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(_data)

        reader.onloadend = function (e) {
          try {
            self.onReceive(new Uint8Array(reader.result))
          } catch (e) {
            logger.error(e)
            self.reConnect()
          }
        }
      } else {
        self.onReceive(new Uint8Array(_data))
      }
    } catch (e) {
      logger.error(e)
      self.reConnect()
    }
  },

  onReceive(data) {
    if (data.length > 0) {
      const packet = proto.proresp.Response.deserializeBinary(data).toObject()
      this.ctx.$handles.handProto(packet)
    }
  },

  onClose(event) { //关闭
    this.ctx.$logger.error("socket 关闭", event);
    // this.reConnect()
  },

  send(request) {//数据发送
    if (this._socket != null && this.isConnected()) {
      this._socket.send(request.serializeBinary());
      this.ctx.$logger.log('发送 -- ', request.getCode())
    } else {
      this.ctx.$logger.log('发送 -- 未连接')
    }
  },

  getRequest(code, message){
    const request = new proto.proreq.Request()
    try{
      request.setCode(code)
      if(message){
        request.setDatabytes(message.serializeBinary())
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    return request
  },


  disConnect(){
    if(this._socket != null){
      this._socket.close()
      this._socket.binaryType = null;
      this._socket.onopen = null
      this._socket.onerror = null
      this._socket.onmessage = null
      this._socket.onclose = null
    }
  },

  isConnected() {
    if (this._socket) {
      return this._socket.readyState == WebSocket.OPEN
    } else {
      return false
    }
  },

  isConnecting() {
    if (this._socket) {
      return this._socket.readyState == WebSocket.CONNECTING
    } else {
      return false
    }
  },

  isClosed() {
    if (this._socket) {
      return this._socket.readyState == WebSocket.CLOSED
    } else {
      return true
    }
  },

  isClosing() {
    if (this._socket) {
      return this._socket.readyState == WebSocket.CLOSING
    } else {
      return true
    }
  },

  sendReqRecved(){

  },


  sendAckMsg(id, uid, off) {
    let data = new proto.proreq.AckRequest({})
    data.setTargetid(uid)
    data.setOff(off)
    this.ctx.$logger.log('sendAckMsg ', data)
    let request = this.ctx.$socket.getRequest(2002, data)
    request.setUuid(id)
    this.ctx.$socket.send(request)
  },

  sendGroupAckMsg(id, uid, off) {
    let data = new proto.proreq.AckRequest({})
    data.setTargetid(uid)
    data.setOff(off)
    this.ctx.$logger.log('sendAckMsg ', data)
    let request = this.ctx.$socket.getRequest(2008, data)
    request.setUuid(id)
    this.ctx.$socket.send(request)
  },

  //消息发送
  sendSingleChatMsg(id, type, msg, cb) {
    let data = new proto.proreq.MsgRequest({})
    data.setTargetid(id)
    data.setType(type)
    data.setContext(msg)
    let request = this.ctx.$socket.getRequest(2000, data)
    let uuid = this.guid()
    request.setUuid(uuid)
    this.ctx.$socket.send(request)
    this.ctx.$handles.addSelfMsgCB(uuid,data, cb)
  },

  //群聊消息发送
  sendGroupChatMsg(id, type, msg, cb) {
    let data = new proto.proreq.MsgRequest({})
    data.setTargetid(id)
    data.setType(type)
    data.setContext(msg)
    console.log('xxxxx   ', data)
    let request = this.ctx.$socket.getRequest(2006, data)
    let uuid = this.guid()
    request.setUuid(uuid)
    this.ctx.$socket.send(request)
    this.ctx.$handles.addSelfMsgCB(uuid,data, cb)
  },

  //用于生成uuid
  S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  },
  guid() {
    return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
  },


  _timer:null,
  startHeart(){
    let self = this;
    if(self._timer){
      clearInterval(self._timer)
    }
    this._timer = setInterval(() => {
      self.ctx.$logger.log('发送 -- 心跳')
      self.send(self.getRequest(1000))
    }, 10000)
  },
}

Socket.install = function (Vue, options) {
  Vue.prototype.$socket = Socket
}
export default Socket;



// WEBPACK FOOTER //
// ./src/plugins/net-socket.js